import { useEffect, useState } from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Header from '../../components/Header/Header';
import axiosClient from '../../libs/axiosClient';
import { IBasketDataType, IBasketProductType } from '../Basket/Basket';
import rightArrow from '../../assets/rightArrow.png';
import styles from './Questionnaire.module.scss';
import AppointmentsCalendar from '../../components/AppointmentsCalendar/AppointmentsCalendar';
import pencil from '../../assets/question/pencil.png';
import mPrev from '../../assets/question/mPrev.png';
import minus from '../../assets/minus.png';
import plus from '../../assets/plus.png';
import closeBtn from '../../assets/closeBtn02.png';
import bottomArrow from '../../assets/countryDrop.png';
import {
  IAllItemsType,
  IOptionType,
  IProductDetailType,
} from '../ProductDetail/ProductDetail';
import { useQuery } from 'react-query';
import checkRecentAuth from '../../common/checkRecentAuth';
import UnifiedAuthModal from '../../components/UnifiedAuthModal/UnifiedAuthModal';
const telRegex = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;
const registrationNumberRegex =
  /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-8][0-9]{6}$/;
const nameRegex = /^[ㄱ-ㅎ가-힣a-zA-Z ]+$/;
export const WEEKDAY = ['일', '월', '화', '수', '목', '금', '토'];
interface ISavedPatientType {
  caffeine_sensitivity: number;
  daily_coffee_intake: number;
  diet_pills_experience: string;
  diet_pills_level: number;
  diet_pills_side_effects: string | null;
  disease: null | string;
  height: number;
  is_disease: string;
  is_pregnant: string;
  is_taking_medicines: string;
  phone: string;
  taking_medicines: null | string;
  user_name: string;
  weight: number;
  // 하랑한의원 추가 필드
  is_thyroid_disorder?: string;
  sleep_hours?: string;
  bowel_condition?: string;
}
function Questionnaire() {
  const location = useLocation();
  const isInitial = new URLSearchParams(location.search).get('isInitial');
  const navigate = useNavigate();
  // const { cartId } = useParams();
  const params = useParams();
  const { productId } = useParams();
  const { isDirect } = useParams();
  const [prescriptionProgramList, setPrescriptionProgramList] = useState<any>(
    [],
  );
  const [isAuthenticationModalOpen, setIsAuthenticationModalOpen] = useState(false);
  const [pendingSubmitData, setPendingSubmitData] = useState<any>(null);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [orderData, setOrderData] = useState<IBasketDataType>();
  const [firstOptionOpen, setFirstOptionOpen] = useState(false);
  const [selectedFirstOption, setSelectedFirstOption] = useState<IOptionType>();
  const [firstOptionList, setFirstOptionList] = useState<IOptionType[]>();
  const [secondOptionList, setSecondOptionList] = useState<IOptionType[]>();
  const [secondOptionOpen, setSecondOptionOpen] = useState(false);
  const [selectedAllItems, setSelectedAllItems] = useState<IAllItemsType[]>([]);
  const [thirdOptionOpen, setThirdOptionOpen] = useState(false);
  const [thirdOptionList, setThirdOptionList] = useState<IOptionType[]>();
  const [selectedThirdOption, setSelectedThirdOption] = useState<IOptionType>();
  const [allItemsPrice, setAllItemsPrice] = useState(0);
  const [allItemsCount, setAllItemsCount] = useState(0);
  const [selectedSecondOption, setSelectedSecondOption] =
    useState<IOptionType>();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [paramsNoArray, setParamsNoArray] = useState(false);
  const [actualProductId, setActualProductId] = useState<string | null>(null);

  useEffect(() => {
    if (!params.productId) {
      return;
    }

    if (params.productId?.indexOf('[') !== 0) {
      setParamsNoArray(true);
      setActualProductId(params.productId);
    } else {
      // productId가 배열 형태인 경우 첫 번째 요소 추출
      try {
        const parsed = JSON.parse(params.productId);
        if (Array.isArray(parsed) && parsed.length > 0) {
          setActualProductId(String(parsed[0]));
          setParamsNoArray(true);
        }
      } catch (e) {
        console.error('Failed to parse productId:', e);
      }
    }
  }, [params.productId]);

  // redirect 인증 결과 확인 (인앱 브라우저에서 redirect 후 돌아왔을 때)
  useEffect(() => {
    // location.state에서 인증 결과 확인 (EZIOKRedirect/MobileOKRedirect에서 전달)
    const state = location.state as {
      authSuccess?: boolean;
      authResult?: any;
      pendingData?: any;
      fromRedirect?: boolean;
      authType?: 'eziok' | 'mobileok';
    } | null;

    if (state?.fromRedirect && state?.authSuccess && state?.authResult) {
      console.log('[Questionnaire] Received redirect auth result:', state);

      // 인증 성공 처리 (redirect에서 전달된 pendingData 함께 전달)
      handleAuthSuccess(state.authResult, state.pendingData);

      // location.state 정리 (뒤로가기 시 중복 처리 방지)
      window.history.replaceState({}, document.title);
      return;
    }

    // sessionStorage에서 redirect 결과 확인 (fallback)
    // EZIOKCallback에서 'eziok_result'로 저장, 기존 방식은 'eziok_redirect_result'
    const eziokResultStr = sessionStorage.getItem('eziok_result') || sessionStorage.getItem('eziok_redirect_result');
    const mobileokResultStr = sessionStorage.getItem('mobileok_result') || sessionStorage.getItem('mobileok_redirect_result');

    if (eziokResultStr) {
      try {
        const result = JSON.parse(eziokResultStr);
        sessionStorage.removeItem('eziok_result');
        sessionStorage.removeItem('eziok_redirect_result');
        console.log('[Questionnaire] Found EZIOK redirect result:', result);

        // EZIOKCallback 형식: { success: true, message: '...', data: {...} }
        // 기존 형식: { success: boolean, result: any, authState?: { pendingData: any } }
        if (result.success) {
          // pendingData는 별도 sessionStorage에서 복구
          const savedPendingData = sessionStorage.getItem('auth_pending_data');
          let pendingData = null;
          if (savedPendingData) {
            try {
              pendingData = JSON.parse(savedPendingData);
              sessionStorage.removeItem('auth_pending_data');
            } catch (e) {
              console.error('[Questionnaire] Failed to parse pending data:', e);
            }
          }
          // result.data 또는 result.result (형식 호환)
          handleAuthSuccess({ success: true, message: result.message || '인증 성공', data: result.data || result.result || {} }, pendingData || result.authState?.pendingData);
        }
      } catch (err) {
        console.error('[Questionnaire] Failed to parse EZIOK redirect result:', err);
        sessionStorage.removeItem('eziok_result');
        sessionStorage.removeItem('eziok_redirect_result');
      }
    }

    if (mobileokResultStr) {
      try {
        const result = JSON.parse(mobileokResultStr);
        sessionStorage.removeItem('mobileok_result');
        sessionStorage.removeItem('mobileok_redirect_result');
        console.log('[Questionnaire] Found MobileOK redirect result:', result);

        // MobileOKCallback 형식: { success: true, message: '...', data: {...} }
        if (result.success) {
          // pendingData는 별도 sessionStorage에서 복구
          const savedPendingData = sessionStorage.getItem('auth_pending_data');
          let pendingData = null;
          if (savedPendingData) {
            try {
              pendingData = JSON.parse(savedPendingData);
              sessionStorage.removeItem('auth_pending_data');
            } catch (e) {
              console.error('[Questionnaire] Failed to parse pending data:', e);
            }
          }
          handleAuthSuccess({
            success: true,
            message: result.message || '인증 성공',
            data: result.data || result.result || {},
          }, pendingData || result.authState?.pendingData);
        }
      } catch (err) {
        console.error('[Questionnaire] Failed to parse MobileOK redirect result:', err);
        sessionStorage.removeItem('mobileok_redirect_result');
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (!prescriptionProgramList.includes(Number(productId))) return;
    if (params.productId?.indexOf('[') !== 0) {
      axiosClient
        .get(`/data/product/detail/${productId}/options`)
        .then((res) => setFirstOptionList(res.data.data));
    }
  }, []);

  useEffect(() => {
    // if (!cartId || !isDirect) return;
    // let itemIdList: number[] = JSON.parse(cartId);
    if (params.productId?.indexOf('[') !== 0) return;
    if (!productId || !isDirect) return;
    let itemIdList: number[] = JSON.parse(productId);
    let queryString = `is_direct=${isDirect}`;
    itemIdList.map((id) => {
      queryString += `&cart_ids=${id}`;
    });
    axiosClient.get(`/data/cart?${queryString}`).then((res) => {
      setOrderData(res.data.data);
    });
  }, []);

  function optionSelectCheck() {
    if (selectedAllItems.length == 0) {
      if (!selectedFirstOption) {
        alert('첫 번째 옵션을 선택해주세요.');
        setFirstOptionOpen(true);
      } else if (!selectedSecondOption) {
        alert('두 번째 옵션을 선택해주세요.');
        setSecondOptionOpen(true);
      } else if (!selectedThirdOption) {
        alert('세 번째 옵션을 선택해주세요.');
        setThirdOptionOpen(true);
      }
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    if (!selectedFirstOption || !detail) return;
    // option_depth가 1보다 크면 2depth의 option 정보 받아옴
    if (detail.option_depth > 1) {
      axiosClient
        .get(
          `/data/product/detail/${detail.product_id}/options?option_id=${selectedFirstOption.po_uid}&depth=2`,
        )
        .then((res) => setSecondOptionList(res.data));
      setSecondOptionOpen(true);
    } else {
      //이미 선택된 옵션 중에 같은 옵션이 포함되어있는지 있으면 해당 idx추출
      let includeIdx = -1;
      selectedAllItems.map((item, idx) => {
        if (item.first?.po_uid == selectedFirstOption.po_uid) includeIdx = idx;
      });
      //-1에서 변경이 없다면 기존 선택된 옵션에 포함되어 있지 않은 옵션이므로 새로 추가
      if (includeIdx == -1)
        setSelectedAllItems([
          ...selectedAllItems,
          {
            first: selectedFirstOption,
            count: 1,
          },
        ]);
      //-1이 아닌 변경된 값이면 이미 해당 옵션이 선택되어 있으므로 해당 옵션 수량 증가
      else
        setSelectedAllItems((prev) => {
          let newList = prev;
          newList[includeIdx].count += 1;
          return [...newList];
        });
      setSelectedFirstOption(undefined);
      setSelectedSecondOption(undefined);
    }
    setFirstOptionOpen(false);
  }, [selectedFirstOption]);
  // 첫 번째 옵션 선택시
  // 두 번째 옵션 선택시
  useEffect(() => {
    if (!selectedSecondOption || !selectedFirstOption || !detail) return;
    if (detail.option_depth > 2) {
      axiosClient
        .get(
          `/data/product/detail/${detail.product_id}/options?option_id=${selectedSecondOption.po_uid}&depth=3`,
        )
        .then((res) => setThirdOptionList(res.data));
      setThirdOptionOpen(true);
    } else {
      let includeIdx = -1;
      selectedAllItems.map((item, idx) => {
        if (
          item.first?.po_uid == selectedFirstOption.po_uid &&
          item.second?.po_uid == selectedSecondOption.po_uid
        )
          includeIdx = idx;
      });
      if (includeIdx == -1)
        setSelectedAllItems([
          ...selectedAllItems,
          {
            first: selectedFirstOption,
            second: selectedSecondOption,
            count: 1,
          },
        ]);
      else
        setSelectedAllItems((prev) => {
          let newList = prev;
          newList[includeIdx].count += 1;
          return [...newList];
        });
      setSelectedFirstOption(undefined);
      setSelectedSecondOption(undefined);
    }
    setSecondOptionOpen(false);
  }, [selectedSecondOption]);

  function handleCountChange(index: number, isUp: boolean) {
    setSelectedAllItems((prev) =>
      prev.map((item, idx) => {
        if (idx == index) {
          if (isUp) item.count = item.count + 1;
          else if (!isUp && item.count > 1) item.count = item.count - 1;
        }
        return item;
      }),
    );
  }
  function handleSelectedItemDelete(index: number) {
    setSelectedAllItems((prev) => prev.filter((item, idx) => idx !== index));
  }
  // 선택한 옵션 총 가격
  useEffect(() => {
    let newPrice = 0;
    let newCount = 0;
    for (let i = 0; i < selectedAllItems.length; i++) {
      let price = 0;
      if ('third' in selectedAllItems[i])
        price += selectedAllItems[i].third?.po_poptionprice || 0;
      else if ('second' in selectedAllItems[i])
        price += selectedAllItems[i].second?.po_poptionprice || 0;
      else if ('first' in selectedAllItems[i])
        price += selectedAllItems[i].first?.po_poptionprice || 0;
      newPrice = newPrice + price * selectedAllItems[i].count;
      newCount = newCount + selectedAllItems[i].count;
    }
    setAllItemsPrice(newPrice);
    setAllItemsCount(newCount);
  }, [selectedAllItems]);

  const [detail, setDetail] = useState<IProductDetailType>();

  useEffect(() => {
    if (!params.productId) return;
  }, []);


  // 하랑한의원 조건 확인 함수
  const isHarangHospital = () => {
    if (!orderData?.carts) return false;
    
    for (const company of orderData.carts) {
      if (company.cart) {
        for (const product of company.cart) {
          if (product.product) {
            const hospitalUserId = product.product.hospital_user_id;
            
            if (hospitalUserId === 12) {
              return true;
            }
          }
        }
      }
    }
    return false;
  };

  const { data: detailCacheData } = useQuery<IProductDetailType>(
    ['productDetail', actualProductId],
    () =>
      axiosClient
        .get(`/data/product/detail/${actualProductId}`)
        .then((res) => {
          let list = JSON.parse(
            sessionStorage.getItem('product_ids') || JSON.stringify([]),
          );
          if (!list.includes(res.data.data.product_id))
            list.push(res.data.data.product_id);
          sessionStorage.setItem('product_ids', JSON.stringify(list));
          return res.data.data;
        }),
    {
      retry: 2,
      refetchOnWindowFocus: false,
      enabled: !!paramsNoArray && !!actualProductId,
      onError: () => {
        if (!productId) return;
        const isJson = JSON.parse(productId);
        if (params.productId?.indexOf('[') === 0) return;
        alert('오류가 발생했습니다.');
        navigate('/');
      },
    },
  );

  useEffect(() => {
    if (detailCacheData) {
      setDetail(detailCacheData);
    }
  }, [detailCacheData]);

  function productOptionCal(product: IBasketProductType) {
    let data = { price: 0, count: 0 };
    product.items.map((option) => {
      data.price += option.discount_price * option.count;
      data.count += option.count;
    });
    return data;
  }

  const saveInfo = () => {
    const infomation: any = {};
    infomation.selectedAllItems = selectedAllItems;
    infomation.patientSecurityNumber1 = watch().patientSecurityNumber1;
    infomation.patientSecurityNumber2 = watch().patientSecurityNumber2;
    infomation.reason = watch().reason;
    infomation.cautionCheck = watch().cautionCheck;
    
    // 하랑한의원 추가 필드 저장
    if (isHarangHospital()) {
      infomation.isThyroidDisorder = watch().isThyroidDisorder;
      infomation.sleepHours = watch().sleepHours;
      infomation.bowelCondition = watch().bowelCondition;
    }
    
    sessionStorage.setItem('quesInfo', JSON.stringify(infomation));
  };

  const onSubmit = async (data: any) => {
    if (!detail && prescriptionProgramList.includes(Number(productId))) return;

    // redirect 후 재제출이 아닌 경우에만 옵션 체크
    if (prescriptionProgramList.includes(Number(productId)) && !data._skipAuthCheck) {
      let check = optionSelectCheck();
      if (!check) return;
    }

    // 해외거주여부가 '아니오'인 경우 본인인증 체크
    // data._skipAuthCheck가 true면 redirect 후 재제출이므로 건너뜀
    if (watch().isOverseas === false && !data._skipAuthCheck) {
      const isAuthenticated = await checkRecentAuth();
      if (!isAuthenticated) {
        // 본인인증이 안 되어있으면 데이터 저장하고 모달 띄우기
        // selectedAllItems도 함께 저장 (redirect 후 복구용)
        const pendingData = {
          ...data,
          _savedSelectedAllItems: selectedAllItems,
        };
        setPendingSubmitData(pendingData);

        // redirect 방식 대비: sessionStorage에도 저장 (페이지 이동 시 state 손실 방지)
        try {
          sessionStorage.setItem('auth_pending_data', JSON.stringify(pendingData));
        } catch (e) {
          console.warn('[Questionnaire] Failed to save pending data to sessionStorage:', e);
        }

        setIsAuthenticationModalOpen(true);
        return;
      }
    }

    if (isSubmitting) return;
    setIsSubmitting(true);
    let date = '';
    let time = '';
    let formData = new FormData();
    saveInfo();

    if (prescriptionProgramList.includes(Number(productId))) {
      formData.append('product_id', String(detail && detail.product_id));
      for (let i = 0; i < selectedAllItems.length; i++) {
        if (detail && detail.option_depth <= 1) {
          if (!selectedAllItems[i].first?.po_uid)
            formData.append('option_ids', '0');
          else
            formData.append(
              'option_ids',
              String(selectedAllItems[i].first?.po_uid),
            );
          formData.append('counts', String(selectedAllItems[i].count));
        } else if (detail && detail.option_depth == 2) {
          formData.append(
            'option_ids',
            String(selectedAllItems[i].second?.po_uid),
          );
          formData.append('counts', String(selectedAllItems[i].count));
        } else if (detail && detail.option_depth == 3) {
          formData.append(
            'option_ids',
            String(selectedAllItems[i].third?.po_uid),
          );
          formData.append('counts', String(selectedAllItems[i].count));
        }
      }
      formData.append('is_direct', 'Y');
      axiosClient
        .post('/func/cart', formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(async (res) => {
          let idList: number[] = [];
          res.data.data.cart_ids.map(
            (ids: { status: number; cart_id: number }) => {
              idList.push(ids.cart_id);
            },
          );
          let cartId = JSON.stringify(idList);

          if (isInitial) {
            date = `${appointmentDate!.getFullYear()}-${(
              '0' +
              (appointmentDate!.getMonth() + 1)
            ).slice(-2)}-${appointmentDate!.getDate()}`;
            time =
              (appointmentTime.substring(0, 2) == 'pm' &&
              appointmentTime.substring(2, 4) != '12'
                ? Number(appointmentTime.substring(2, 4)) +
                  12 +
                  ':' +
                  appointmentTime.substring(5, 7)
                : appointmentTime.slice(-5)) + ':00';
            formData.append('is_reservation', 'Y');
            formData.append('reservation_at', `${date} ${time}`);
          } else formData.append('is_reservation', 'N');
          formData.append('user_name', watch().patientName);
          formData.append('phone', watch().patientTel);
          formData.append('height', watch().patientHeight);
          formData.append('weight', watch().patientWeight);
          formData.append('is_pregnant', watch().pregnancy ? 'Y' : 'N');
          formData.append('is_overseas', watch().isOverseas ? 'Y' : 'N');
          formData.append('daily_coffee_intake', String(watch().dailyCoffee));
          formData.append(
            'caffeine_sensitivity',
            String(watch().caffeineSensitivity),
          );
          watch().dietPillsExperience.map((val: boolean, idx: number) => {
            if (val) formData.append('diet_pills_experience', String(idx + 1));
          });
          if (!watch().dietPillsExperience[0] && !isSupplyment) {
            formData.append('diet_pills_level', String(watch().dietPillsLevel));
            formData.append(
              'diet_pills_side_effects',
              String(watch().sideEffects || ''),
            );
          }
          formData.append('is_disease', watch().disease ? 'Y' : 'N');
          formData.append(
            'disease',
            watch().disease ? watch().diseaseDetail || '' : '',
          );
          formData.append('is_taking_medicines', watch().medicine ? 'Y' : 'N');
          formData.append(
            'taking_medicines',
            watch().medicine ? watch().medicineDetail || '' : '',
          );
          await axiosClient.post('/func/prescription', formData).then((res) => {
            navigate(`/order-addr/${isDirect}/${cartId}`, {
              state: {
                isReservation: isInitial ? 'Y' : 'N',
                reservationAt: isInitial ? `${date} ${time}` : null,
                patientName: watch().patientName,
                patientTel: watch().patientTel,
                patientSecurityNumber1: watch().patientSecurityNumber1,
                patientSecurityNumber2: isInitial
                  ? '0000000'
                  : watch().patientSecurityNumber2,
                patientHeight: watch().patientHeight,
                patientWeight: watch().patientWeight,
                reason: watch().isOverseas ? `해외 거주중
${watch().reason}` : watch().reason,
                pregnancy: watch().pregnancy,
                isOverseas: watch().isOverseas,
                dailyCoffee: watch().dailyCoffee,
                caffeineSensitivity: watch().caffeineSensitivity,
                dietPillsExperience: watch().dietPillsExperience,
                dietPillsLevel: watch().dietPillsLevel,
                sideEffects: watch().sideEffects || '',
                disease: watch().disease,
                medicine: watch().medicine,
                diseaseDetail: watch().diseaseDetail || '',
                medicineDetail: watch().medicineDetail || '',
              },
            });
          });
        });
    } else {
      if (isInitial) {
        date = `${appointmentDate!.getFullYear()}-${(
          '0' +
          (appointmentDate!.getMonth() + 1)
        ).slice(-2)}-${appointmentDate!.getDate()}`;
        time =
          (appointmentTime.substring(0, 2) == 'pm' &&
          appointmentTime.substring(2, 4) != '12'
            ? Number(appointmentTime.substring(2, 4)) +
              12 +
              ':' +
              appointmentTime.substring(5, 7)
            : appointmentTime.slice(-5)) + ':00';
        formData.append('is_reservation', 'Y');
        formData.append('reservation_at', `${date} ${time}`);
      } else formData.append('is_reservation', 'N');
      formData.append('user_name', watch().patientName);
      formData.append('phone', watch().patientTel);
      formData.append('height', watch().patientHeight);
      formData.append('weight', watch().patientWeight);
      formData.append('is_pregnant', watch().pregnancy ? 'Y' : 'N');
      formData.append('is_overseas', watch().isOverseas ? 'Y' : 'N');
      formData.append('daily_coffee_intake', String(watch().dailyCoffee));
      formData.append(
        'caffeine_sensitivity',
        String(watch().caffeineSensitivity),
      );
      watch().dietPillsExperience.map((val: boolean, idx: number) => {
        if (val) formData.append('diet_pills_experience', String(idx + 1));
      });
      if (!watch().dietPillsExperience[0] && !isSupplyment) {
        formData.append('diet_pills_level', String(watch().dietPillsLevel));
        formData.append(
          'diet_pills_side_effects',
          String(watch().sideEffects || ''),
        );
      }
      formData.append('is_disease', watch().disease ? 'Y' : 'N');
      formData.append(
        'disease',
        watch().disease ? watch().diseaseDetail || '' : '',
      );
      formData.append('is_taking_medicines', watch().medicine ? 'Y' : 'N');
      formData.append(
        'taking_medicines',
        watch().medicine ? watch().medicineDetail || '' : '',
      );
      
      // 하랑한의원 추가 필드 처리
      if (isHarangHospital()) {
        formData.append('is_thyroid_disorder', data.isThyroidDisorder || 'N');
        formData.append('sleep_hours', data.sleepHours || '');
        formData.append('bowel_condition', data.bowelCondition || '');
      }
      await axiosClient.post('/func/prescription', formData).then((res) => {
        navigate(`/order-addr/${isDirect}/${productId}`, {
          state: {
            isReservation: isInitial ? 'Y' : 'N',
            reservationAt: isInitial ? `${date} ${time}` : null,
            patientName: watch().patientName,
            patientTel: watch().patientTel,
            patientSecurityNumber1: watch().patientSecurityNumber1,
            patientSecurityNumber2: isInitial
              ? '0000000'
              : watch().patientSecurityNumber2,
            patientHeight: watch().patientHeight,
            patientWeight: watch().patientWeight,
            reason: watch().reason,
            pregnancy: watch().pregnancy,
            isOverseas: watch().isOverseas,
            dailyCoffee: watch().dailyCoffee,
            caffeineSensitivity: watch().caffeineSensitivity,
            dietPillsExperience: watch().dietPillsExperience,
            dietPillsLevel: watch().dietPillsLevel,
            sideEffects: watch().sideEffects || '',
            disease: watch().disease,
            medicine: watch().medicine,
            diseaseDetail: watch().diseaseDetail || '',
            medicineDetail: watch().medicineDetail || '',
          },
        });
      });
    }
    setIsSubmitting(false);
  };
  const onSubmitError = (error: any) => {
    let errorList: { message: string; ref: HTMLElement }[] =
      Object.values(error);
    if (errorList[0].message.includes('예약 희망 날짜')) setCalendarOpen(true);
    window.scrollTo(
      0,
      window.scrollY + errorList[0].ref.getBoundingClientRect().top - 150,
    );
    alert(errorList[0].message);
  };

  useEffect(() => {
    axiosClient.get('/data/prescription').then((res) => {
      let result: ISavedPatientType = res.data.data;
      if (Object.keys(result).length == 0) return;
      if (nameRegex.test(result.user_name))
        setValue('patientName', result.user_name);
      if (result.phone) setValue('patientTel', result.phone.trim().replace(/-/g, ''));
      const savedQuesInfo = JSON.parse(
        sessionStorage.getItem('quesInfo') || JSON.stringify(''),
      );
      if (savedQuesInfo) {
        if (savedQuesInfo?.selectedAllItems)
          setSelectedAllItems(savedQuesInfo.selectedAllItems);
        setValue('patientSecurityNumber1', savedQuesInfo.patientSecurityNumber1);
        setValue('patientSecurityNumber2', savedQuesInfo.patientSecurityNumber2);
        setValue('reason', savedQuesInfo.reason);
        setValue('cautionCheck', savedQuesInfo.cautionCheck);
      }
      // 본인인증 직후에는 저장된 문진표 없이 이름/연락처만 담긴 응답이 올 수 있다.
      // 이 경우 아래 문진 항목들을 undefined로 덮어쓰면 안 되므로 실제 문진표가 있을 때만 채운다.
      // 또한 이미 폼에 답변이 있으면(본인인증 복귀 자동복원, 작성 중) 덮어쓰지 않는다.
      if (result.daily_coffee_intake == null || watch().dailyCoffee) return;
      setValue('patientHeight', String(result.height));
      setValue('patientWeight', String(result.weight));
      setValue('pregnancy', result.is_pregnant == 'Y' ? true : false);
      setValue('isOverseas', false); // 기본값: 국내 거주
      setValue('dailyCoffee', result.daily_coffee_intake);
      setValue('caffeineSensitivity', result.caffeine_sensitivity);
      setValue(
        'dietPillsExperience',
        (() => {
          let newVal = [false, false, false, false];
          (result.diet_pills_experience || '').split(',').map((num: string) => {
            newVal[Number(num) - 1] = true;
          });
          return newVal;
        })(),
      );
      setValue('dietPillsLevel', result.diet_pills_level);
      setValue('sideEffects', result.diet_pills_side_effects || '');
      setValue('disease', result.is_disease == 'Y' ? true : false);
      setValue('diseaseDetail', result.disease || '');
      setValue('medicine', result.is_taking_medicines == 'Y' ? true : false);
      setValue('medicineDetail', result.taking_medicines || '');
      
      // 하랑한의원 추가 필드 설정
      if (isHarangHospital()) {
        setValue('isThyroidDisorder', result.is_thyroid_disorder || 'N');
        setValue('sleepHours', result.sleep_hours || '');
        setValue('bowelCondition', result.bowel_condition || '');
      }

    });
  }, []);
  const [appointmentDate, setAppointmentDate] = useState<Date | null>(null);
  const [appointmentTime, setAppointmentTime] = useState('');
  const [calendarOpen, setCalendarOpen] = useState(false);
  useEffect(() => {
    setAppointmentTime('');
  }, [appointmentDate]);
  useEffect(() => {
    if (!appointmentDate || !appointmentTime) {
      setValue('appointmentDate', '');
      return;
    }
    setCalendarOpen(false);
    setValue(
      'appointmentDate',
      `${appointmentDate.getFullYear()}.${
        appointmentDate.getMonth() + 1
      }.${appointmentDate.getDate()}(${WEEKDAY[appointmentDate.getDay()]}) / ${
        appointmentTime.substring(0, 2) == 'am' ? '오전' : '오후'
      } ${appointmentTime.substring(2)}`,
    );
  }, [appointmentTime]);

  // 보조제만 선택했는지 확인
  const [isSupplyment, setIsSupplyment] = useState(false);

  useEffect(() => {
    // 보조제만 선택한 경우
    if (
      watch().dietPillsExperience[3] === true &&
      watch()
        .dietPillsExperience.slice(0, 3)
        .every((item: boolean) => item === false)
    ) {
      setIsSupplyment(true);
      setValue('dietPillsLevel', 0);
      setValue('sideEffects', '');
    } else setIsSupplyment(false);
  }, [watch().dietPillsExperience, watch().sideEffects]);

  function resetAppointment() {
    setAppointmentDate(null);
    setAppointmentTime('');
    setValue('appointmentDate', '');
  }
  function copyAddress() {
    navigator.clipboard
      .writeText('서울 강남구 테헤란로64길 8 지하1층')
      .then((res) => alert('주소가 복사되었습니다.'));
  }

  // 본인인증 성공 후 처리
  const handleAuthSuccess = (result: any, redirectPendingData?: any) => {
    console.log('[Questionnaire] 본인인증 성공:', result);
    setIsAuthenticationModalOpen(false);

    // redirect 방식에서 전달된 pendingData 또는 기존 state의 pendingSubmitData 사용
    const dataToSubmit = redirectPendingData || pendingSubmitData;

    // 저장된 데이터로 다시 submit
    if (dataToSubmit) {
      console.log('[Questionnaire] Re-submitting with pending data:', dataToSubmit);

      // redirect 후 복구 시 savedSelectedAllItems가 있으면 복구
      const savedItems = dataToSubmit._savedSelectedAllItems;
      if (savedItems && savedItems.length > 0) {
        console.log('[Questionnaire] Restoring selectedAllItems:', savedItems);
        setSelectedAllItems(savedItems);
      }

      // _skipAuthCheck 플래그 추가하여 인증/옵션 체크 건너뛰기
      // _savedSelectedAllItems는 제거 (form data에 불필요)
      const { _savedSelectedAllItems, ...cleanData } = dataToSubmit;

      // redirect 후 form 필드 값 복구 (watch()가 올바른 값을 반환하도록)
      Object.keys(cleanData).forEach(key => {
        if (!key.startsWith('_')) {  // 내부 키(_skipAuthCheck 등) 제외
          setValue(key, cleanData[key]);
        }
      });
      console.log('[Questionnaire] Form values restored');

      const submitData = {
        ...cleanData,
        _skipAuthCheck: true,
      };

      // state 및 form 업데이트 후 submit (비동기 문제 해결)
      setTimeout(() => {
        handleSubmit(onSubmit, onSubmitError)(submitData);
      }, 200);

      setPendingSubmitData(null);
    }
  };

  // 본인인증 모달 닫기
  const handleAuthModalClose = () => {
    setIsAuthenticationModalOpen(false);
    setPendingSubmitData(null);
    // sessionStorage도 정리
    sessionStorage.removeItem('auth_pending_data');
  };

  return (
    <div className={`${styles.container} ${!isDesktop ? styles.isMobile : ''}`}>
      {isDesktop && <Header />}
      <div className={styles.contentArea}>
        {isInitial && (
          <section className={styles.appointmentWrap}>
            <h3>병원 방문 예약하기</h3>
            <article className={styles.hospitalInfoWrap}>
              <div className={styles.hospitalDetail}>
                <h1>압구정 당봄한의원</h1>
                <div
                  onClick={() => {
                    window.open(
                      'https://map.naver.com/v5/search/%EB%A7%88%EB%94%94%EB%A1%9C%ED%95%9C%EC%9D%98%EC%9B%90/place/1036931386?c=15,0,0,0,dh&placePath=%3Fentry%253Dbmp',
                      '_blank',
                    );
                  }}
                >
                  <span>지도보기</span>
                  <img src={rightArrow} alt="화살표" />
                </div>
              </div>
              <div className={styles.hospitalAddress}>
                <h6>병원주소</h6>
                <div className={styles.addressDetail}>
                  <span>서울 강남구 테헤란로64길 8 지하1층</span>
                  <div className={styles.copyBtn} onClick={copyAddress}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M11.9583 4.66675V11.0834H3.79163V1.16675H8.74996M11.9583 4.66675H8.74996V1.16675M11.9583 4.66675L8.74996 1.16675"
                        stroke="#FF5656"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.04163 5.8335V12.8335H8.16663"
                        stroke="#FF5656"
                        strokeLinecap="square"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5.54163 5.8335H6.70829M5.54163 8.16683H9.04163"
                        stroke="#FF5656"
                        strokeLinecap="square"
                      />
                    </svg>
                    <span>복사</span>
                  </div>
                </div>
              </div>
            </article>
            <article
              className={styles.appointmentDateWrap}
              {...register('appointmentDate', {
                value: '',
                required: {
                  value: !watch().appointmentDate,
                  message: '예약 희망 날짜를 선택해주세요.',
                },
              })}
            >
              <div className={styles.label}>
                <div className={styles.left}>
                  <span>*</span>
                  <span>예약 희망 날짜</span>
                </div>
                <div className={styles.right}>
                  <div className={styles.dropboxWrap}>
                    <div
                      className={styles.dropbox}
                      onClick={() => setCalendarOpen((prev) => !prev)}
                    >
                      <span>옵션을 선택해주세요.</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 22 22"
                        fill="none"
                        style={{
                          transform: calendarOpen ? 'rotate(180deg)' : 'unset',
                        }}
                      >
                        <path
                          d="M3.5 7.5L11 14.5L18.5 7.5"
                          stroke="#D1D0D5"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                    {calendarOpen && (
                      <AppointmentsCalendar
                        appointmentDate={appointmentDate}
                        setAppointmentDate={setAppointmentDate}
                        appointmentTime={appointmentTime}
                        setAppointmentTime={setAppointmentTime}
                      />
                    )}
                  </div>
                  {watch().appointmentDate && (
                    <div className={styles.appointmentInfo}>
                      <span>{watch().appointmentDate}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        onClick={resetAppointment}
                      >
                        <path
                          d="M15.8332 4.16675L4.1665 15.8334M4.16652 4.16675L15.8332 15.8334"
                          stroke="#131C31"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  )}
                  {/* <p>
                                        *병원 스케줄에 따라 예약 날짜가 변경될
                                        수 있습니다.
                                        <br />
                                        접수 완료 후, 방문 시간 안내 전화를
                                        드립니다.
                                    </p> */}
                </div>
              </div>
            </article>
          </section>
        )}
        {!isDesktop && (
          <div className={styles.prevWrap}>
            <img onClick={() => navigate(-1)} src={mPrev} alt="mPrev" />
          </div>
        )}
        <div className={styles.left}>
          <div className={styles.stepTitleWrap}>
            <span>결제하기</span>
            <div className={styles.stepWrap}>
              <span>문진표작성</span>
              <div className={styles.hitStep}>1</div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={styles.orderTitleWrap}>
            <img src={pencil} alt="pencil" />
            <span>문진표 작성</span>
          </div>
          {prescriptionProgramList.includes(detail?.product_id) && (
            <div className={styles.productListWrap}>
              {prescriptionProgramList.includes(detail?.product_id) && (
                <div className={styles.productInfoWrap}>
                  <div className={styles.thumbnailWrap}>
                    <img src={detail && detail.list_image} alt="thumbnail" />
                  </div>
                  <div className={styles.productInfo}>
                    <h3 className={styles.productName}>
                      {detail && detail.title}
                    </h3>
                    <div className={styles.optionWrap}>
                      <div className={styles.option}>
                        <span>필수 옵션</span>
                        <div
                          className={styles.optionBox}
                          onClick={() => setFirstOptionOpen((prev) => !prev)}
                        >
                          <span
                            style={{
                              color: selectedFirstOption
                                ? '#131C31'
                                : '#abb1bb',
                            }}
                          >
                            {selectedFirstOption
                              ? selectedFirstOption.po_poptionname
                              : '옵션을 선택해주세요.'}
                          </span>
                          <img
                            src={bottomArrow}
                            alt="bottomArrow"
                            style={{
                              transform: firstOptionOpen
                                ? 'rotate(180deg)'
                                : 'none',
                            }}
                          />
                          {firstOptionOpen && (
                            <ul className={styles.optionList}>
                              {detail && detail.option_depth > 0 ? (
                                firstOptionList?.map((option) => (
                                  <li
                                    key={option.po_uid}
                                    onClick={() =>
                                      setSelectedFirstOption(option)
                                    }
                                  >
                                    {option.po_poptionname}
                                  </li>
                                ))
                              ) : (
                                <li
                                  onClick={() =>
                                    setSelectedFirstOption({
                                      po_poptionname: detail && detail.title,
                                      po_poptionprice:
                                        detail && detail.discount_price,
                                      po_uid: 0,
                                    })
                                  }
                                >
                                  {detail && detail.title}
                                </li>
                              )}
                            </ul>
                          )}
                        </div>
                      </div>
                      {detail && detail.option_depth > 1 && (
                        <div className={styles.option}>
                          <span>필수 옵션</span>
                          <div
                            className={styles.optionBox}
                            onClick={() => {
                              if (!selectedFirstOption) {
                                alert('첫 번째 옵션을 선택해주세요.');
                                setFirstOptionOpen(true);
                                return;
                              }
                              setSecondOptionOpen((prev) => !prev);
                            }}
                          >
                            <span>옵션을 선택해주세요.</span>
                            <img
                              src={bottomArrow}
                              alt="bottomArrow"
                              style={{
                                transform: secondOptionOpen
                                  ? 'rotate(180deg)'
                                  : 'none',
                              }}
                            />
                            {secondOptionOpen && (
                              <ul className={styles.optionList}>
                                {secondOptionList?.map((option) => (
                                  <li
                                    key={option.po_uid}
                                    onClick={() =>
                                      setSelectedSecondOption(option)
                                    }
                                  >
                                    {option.po_poptionname}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {selectedAllItems.length > 0 && (
                <ul className={styles.selectedOptionListWrap}>
                  {selectedAllItems.map((option, idx) => (
                    <li key={idx}>
                      <div className={!isDesktop ? styles.isMobile : ''}>
                        <span className={styles.optionName}>
                          {`${option.first?.po_poptionname}`}
                          {option.second &&
                            ` / ${option.second?.po_poptionname}`}
                          {option.third && ` / ${option.third?.po_poptionname}`}
                        </span>
                        <div className={styles.counter}>
                          <div
                            className={styles.minus}
                            onClick={() => handleCountChange(idx, false)}
                          >
                            <img src={minus} alt="minus" />
                          </div>
                          <div className={styles.count}>{option.count}</div>
                          <div
                            className={styles.plus}
                            onClick={() => handleCountChange(idx, true)}
                          >
                            <img src={plus} alt="plus" />
                          </div>
                        </div>
                        <div className={styles.editBox}>
                          <div className={styles.optionPrice}>
                            <span>
                              {option.third &&
                              option.third.po_poption_supplyprice
                                ? option.third.po_poption_supplyprice?.toLocaleString() ||
                                  ''
                                : option.second &&
                                  option.second.po_poption_supplyprice
                                ? option.second.po_poption_supplyprice?.toLocaleString() ||
                                  ''
                                : (option.first.po_poption_supplyprice &&
                                    option.first.po_poption_supplyprice!.toLocaleString()) ||
                                  ''}
                            </span>
                            <span>
                              {option.third
                                ? option.third.po_poptionprice?.toLocaleString()
                                : option.second
                                ? option.second.po_poptionprice?.toLocaleString()
                                : option.first.po_poptionprice!.toLocaleString()}
                            </span>
                          </div>
                          <img
                            src={closeBtn}
                            alt="closeBtn"
                            onClick={() => handleSelectedItemDelete(idx)}
                          />
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              {prescriptionProgramList.includes(detail?.product_id) && (
                <div className={styles.totalPriceWrap}>
                  <span className={styles.head}>총 금액</span>
                  <span className={styles.totalPrice}>
                    <span>{allItemsPrice.toLocaleString()}원</span>
                    <span>{allItemsCount !== 0 && `(${allItemsCount}개)`}</span>
                  </span>
                </div>
              )}
              {!prescriptionProgramList.includes(detail?.product_id) &&
                orderData?.carts.map((company) =>
                  company.cart.map((product) => (
                    <div
                      className={styles.productInfoWrap}
                      key={product.product.product_id}
                    >
                      <div className={styles.thumbnailWrap}>
                        <img src={product.product.list_image} alt="thumbnail" />
                      </div>
                      <div className={styles.productInfo}>
                        <h3 className={styles.productName}>
                          {product.product.title}
                        </h3>
                        <ul className={styles.optionList}>
                          {product.product.option_depth > 0 &&
                            product.items.map((option) => (
                              <li key={option.id}>
                                <span>
                                  {option.option1 && option.option1}
                                  {option.option2 && ' / ' + option.option2}
                                  {option.option3 && ' / ' + option.option3}
                                </span>
                                <span>수량 {option.count}개</span>
                              </li>
                            ))}
                        </ul>
                        <div className={styles.totalInfoWrap}>
                          {(() => {
                            let res = productOptionCal(product);
                            return (
                              <>
                                <span>{res.price.toLocaleString()}원</span>
                                <span>수량 {res.count}개</span>
                              </>
                            );
                          })()}
                        </div>
                      </div>
                    </div>
                  )),
                )}
            </div>
          )}
          <div className={styles.questionnaireWrap}>
            <form
              className={styles.questionnaireForm}
              onSubmit={(e) => e.preventDefault()}
            >
              <label className={`${styles.label} ${styles.nameLabel}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>이름</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.patientName ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    placeholder="이름"
                    className={`${styles.normalInput} name`}
                    {...register('patientName', {
                      value: '',
                      required: {
                        value: true,
                        message: '이름은 필수 입력사항입니다.',
                      },
                      pattern: {
                        value: nameRegex,
                        message: '올바른 이름 형식이 아닙니다.',
                      },
                    })}
                  />
                </div>
                <p>한글, 영문, 공백만 사용 가능합니다.</p>
              </label>
              <label className={styles.phoneNumberLabel}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>연락처</span>
                </div>
                <div className={styles.box}>
                  <div
                    className={`${styles.phoneNumberInuptWrap} ${
                      errors.patientTel ? styles.validationError : ''
                    }`}
                  >
                    <input
                      type="text"
                      placeholder=""
                      className={`${styles.normalInput} tel`}
                      {...register('patientTel', {
                        value: '',
                        required: {
                          value: true,
                          message: '연락처는 필수 입력사항입니다.',
                        },
                        minLength: {
                          value: 8,
                          message: '연락처를 올바르게 입력해주세요.',
                        },
                        onChange: (e) => {
                          let value = e.currentTarget.value;
                          if (!/^[0-9]+$/g.test(value)) {
                            setValue(
                              'patientTel',
                              value.slice(0, value.length - 1),
                            );
                          }
                        },
                      })}
                    />
                  </div>
                  <p>
                    의료진이 진료를 위해 전화를 드리므로 이름과 연락처를
                    {isMobile && <br />}
                    정확하게 기재해주셔야 빠른 진료를 받으실수 있습니다.
                  </p>
                </div>
              </label>
              <label className={styles.securityNumberLabel}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>주민등록번호 {isInitial && '앞자리'}</span>
                </div>
                <div>
                  <div
                    className={`${styles.securityNumberInuptWrap} ${
                      errors.patientSecurityNumber1 ||
                      errors.patientSecurityNumber2
                        ? styles.validationError
                        : ''
                    }`}
                  >
                    <input
                      type="number"
                      {...register('patientSecurityNumber1', {
                        value: '',
                        required: {
                          value: true,
                          message: '주민등록번호를 입력해주세요.',
                        },
                        maxLength: {
                          value: 6,
                          message:
                            '주민등록번호 앞자리를 6글자로 작성해주세요.',
                        },
                        minLength: {
                          value: 6,
                          message:
                            '주민등록번호 앞자리를 6글자로 작성해주세요.',
                        },
                        pattern: {
                          value: /^[0-9]{6}$/,
                          message: '주민등록번호는 숫자만 입력 가능합니다.',
                        },
                        onChange: (e) => {
                          if (e.currentTarget.value.length > 6)
                            setValue(
                              'patientSecurityNumber1',
                              e.currentTarget.value.slice(0, 6),
                            );
                        },
                      })}
                      max={9999}
                      maxLength={6}
                      className={isInitial ? styles.fullWidth : ''}
                      placeholder="000000"
                    />
                    {!isInitial && (
                      <>
                        <span>-</span>
                        <input
                          type="password"
                          autoComplete="off"
                          {...register('patientSecurityNumber2', {
                            value: '',
                            required: {
                              value: true,
                              message: '주민등록번호를 입력해주세요.',
                            },
                            minLength: {
                              value: 7,
                              message:
                                '주민등록번호 뒷자리를 7글자로 작성해주세요.',
                            },
                            onChange: (e) => {
                              if (isNaN(Number(e.currentTarget.value)))
                                setValue(
                                  'patientSecurityNumber2',
                                  e.currentTarget.value.slice(
                                    0,
                                    e.currentTarget.value.length - 1,
                                  ),
                                );
                              if (e.currentTarget.value.length > 7)
                                setValue(
                                  'patientSecurityNumber2',
                                  e.currentTarget.value.slice(0, 7),
                                );
                            },
                          })}
                          placeholder="0000000"
                        />
                      </>
                    )}
                  </div>
                  <p>
                    비대면 진료를 받기 위해서는 의료법에 의해 의료기관이
                    주민번호를 확인합니다. 다이어트 닥터는 해당 정보를 확인할 수
                    없습니다.
                    <br />
                    *해외거주자 분들은 임의로 입력해주세요.
                  </p>
                </div>
              </label>
              <div
                  className={`${styles.pregnancyLabel} ${
                      errors.isOverseas ? styles.warning : ''
                  }`}
                  {...register('isOverseas', {
                    required: {
                      value: watch().isOverseas == undefined,
                      message: '해외 거주 여부를 선택해주세요.',
                    },
                  })}
              >
                <div>
                  <span>*</span>
                  <span>해외 거주 여부</span>
                </div>
                <div className={styles.checkOutWrap}>
                  <div
                      className={`${styles.customCheckBoxWrap} ${
                          watch().isOverseas ? styles.hit : ''
                      } isOverseas`}
                      onClick={() => setValue('isOverseas', true)}
                  >
                    <div className={styles.customCheckBox}></div>
                    <span>예</span>
                  </div>
                  <div
                      className={`${styles.customCheckBoxWrap} ${
                          watch().isOverseas === false ? styles.hit : ''
                      }`}
                      onClick={() => setValue('isOverseas', false)}
                  >
                    <div className={styles.customCheckBox}></div>
                    <span>아니오</span>
                  </div>
                </div>
                <p style={{
                  marginTop: '10px',
                  fontSize: '13px',
                  color: '#666',
                  lineHeight: '1.5',
                  marginBottom: '20px'
                }}>
                  해외 거주 여부를 부정확하게 입력할 경우, 원활한 진료 처리가 불가능하며 서비스 이용에 제한이 발생할 수 있습니다.<br/>
                  반드시 사실대로 정확히 입력하시기 바랍니다.
                </p>
              </div>
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>키</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.patientHeight ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    className={`${styles.normalInput} height`}
                    {...register('patientHeight', {
                      value: '',
                      required: {
                        value: true,
                        message: '키를 입력해주세요.',
                      },
                      validate: (value) =>
                        Number(value) > 0 || '키는 0보다 커야 합니다.',
                      onChange: (e) => {
                        let value = e.currentTarget.value;
                        if (isNaN(Number(e.currentTarget.value)))
                          setValue(
                            'patientHeight',
                            value.slice(0, value.length - 1),
                          );
                      },
                    })}
                  />
                  <span className={styles.inputUnit}>cm</span>
                </div>
              </label>
              <label className={styles.label}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>체중</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.patientWeight ? styles.validationError : ''
                  }`}
                >
                  <input
                    type="text"
                    className={`${styles.normalInput} weight`}
                    {...register('patientWeight', {
                      value: '',
                      required: {
                        value: true,
                        message: '체중을 입력해주세요.',
                      },
                      validate: (value) =>
                        Number(value) > 0 || '체중은 0보다 커야 합니다.',
                      onChange: (e) => {
                        let value = e.currentTarget.value;
                        if (isNaN(Number(e.currentTarget.value)))
                          setValue(
                            'patientWeight',
                            value.slice(0, value.length - 1),
                          );
                      },
                    })}
                    // value={patientWeight}
                    // onChange={(e) => {
                    //   let value = e.currentTarget.value;
                    //   if (isNaN(Number(e.currentTarget.value))) return;
                    //   setPatientWeight(value);
                    // }}
                    // onBlur={() => setPatientWeight((prev) => prev.trim())}
                  />
                  <span className={styles.inputUnit}>kg</span>
                </div>
              </label>
              <label className={`${styles.label} ${styles.reasonLabel}`}>
                <div className={styles.labelWrap}>
                  <span>*</span>
                  <span>상담사유</span>
                </div>
                <div
                  className={`${styles.inputWrap} ${
                    errors.reason ? styles.validationError : ''
                  }`}
                >
                  <textarea
                    className={`${styles.reason} reason`}
                    {...register('reason', {
                      value: '',
                      required: {
                        value: true,
                        message: '상담사유를 입력해주세요.',
                      },
                    })}
                    placeholder="다이어트"
                  ></textarea>
                </div>
              </label>
              <div
                className={`${styles.pregnancyLabel} ${
                  errors.pregnancy ? styles.warning : ''
                }`}
                {...register('pregnancy', {
                  required: {
                    value: watch().pregnancy == undefined,
                    message: '임신 여부를 선택해주세요.',
                  },
                })}
              >
                <div>
                  <span>*</span>
                  <span>임신 여부</span>
                </div>
                <div className={styles.checkOutWrap}>
                  <div
                    className={`${styles.customCheckBoxWrap} ${
                      watch().pregnancy ? styles.hit : ''
                    } pregnancy`}
                    onClick={() => setValue('pregnancy', true)}

                    // onClick={() => setPregnancy(true)}
                  >
                    <div className={styles.customCheckBox}></div>
                    <span>예</span>
                  </div>
                  <div
                    className={`${styles.customCheckBoxWrap} ${
                      watch().pregnancy === false ? styles.hit : ''
                    }`}
                    onClick={() => setValue('pregnancy', false)}

                    // onClick={() => setPregnancy(false)}
                  >
                    <div className={styles.customCheckBox}></div>
                    <span>아니오</span>
                  </div>
                </div>
              </div>
              {/* 하랑한의원 전용 추가 문진 필드 */}
              {isHarangHospital() && (
                <>
                  {/* 갑상선 기능 이상 유무 */}
                  <div
                    className={`${styles.pregnancyLabel} ${
                      errors.isThyroidDisorder ? styles.warning : ''
                    }`}
                    {...register('isThyroidDisorder', {
                      required: {
                        value: isHarangHospital() && watch().isThyroidDisorder == undefined,
                        message: '갑상선 기능 이상 유무를 선택해주세요.',
                      },
                    })}
                  >
                    <div>
                      <span>*</span>
                      <span>갑상선 기능 이상 유무</span>
                    </div>
                    <div className={styles.checkOutWrap}>
                      <div
                        className={`${styles.customCheckBoxWrap} ${
                          watch().isThyroidDisorder === 'Y' ? styles.hit : ''
                        }`}
                        onClick={() => setValue('isThyroidDisorder', 'Y')}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>예</span>
                      </div>
                      <div
                        className={`${styles.customCheckBoxWrap} ${
                          watch().isThyroidDisorder === 'N' ? styles.hit : ''
                        }`}
                        onClick={() => setValue('isThyroidDisorder', 'N')}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>아니오</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* 평소 수면시간 */}
                  <label className={styles.label}>
                    <div className={styles.labelWrap}>
                      <span>*</span>
                      <span>평소 수면시간</span>
                    </div>
                    <div
                      className={`${styles.inputWrap} ${
                        errors.sleepHours ? styles.validationError : ''
                      }`}
                    >
                      <input
                        type="text"
                        className={`${styles.normalInput} sleepHours`}
                        {...register('sleepHours', {
                          required: {
                            value: isHarangHospital() || false,
                            message: '평소 수면시간을 입력해주세요.',
                          },
                        })}
                        placeholder="예: 7-8시간, 6시간 30분"
                      />
                    </div>
                  </label>
                  
                  {/* 평소 배변상태 */}
                  <label className={styles.label}>
                    <div className={styles.labelWrap}>
                      <span>*</span>
                      <span>평소 배변상태</span>
                    </div>
                    <div
                      className={`${styles.inputWrap} ${
                        errors.bowelCondition ? styles.validationError : ''
                      }`}
                    >
                      <input
                        type="text"
                        className={`${styles.normalInput} bowelCondition`}
                        {...register('bowelCondition', {
                          required: {
                            value: isHarangHospital() || false,
                            message: '평소 배변상태를 입력해주세요.',
                          },
                        })}
                        placeholder="예: 정상, 변비, 설사, 불규칙"
                      />
                    </div>
                  </label>
                </>
              )}
            </form>
          </div>
          <div className={`${styles.prescriptionDetailWrap}`}>
            <label
              className={`${styles.label} ${
                errors.dailyCoffee ? styles.warning : ''
              } dailyCoffee`}
              {...register('dailyCoffee', {
                value: 0,
                validate: () =>
                  !/^[1-9]$/g.test(watch().dailyCoffee)
                    ? '하루 섭취 커피량을 선택해주세요.'
                    : true,
              })}
            >
              <div className={styles.labelWrap}>
                <span>*</span>
                <span>하루 커피량</span>
              </div>
              <ul
                className={`${styles.checkboxArea} ${
                  isMobile ? styles.isMobile : ''
                }`}
              >
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 1 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 1)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>0잔</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 2 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 2)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>1잔</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 3 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 3)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>2잔</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dailyCoffee == 4 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('dailyCoffee', 4)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>3잔 이상</span>
                </li>
              </ul>
            </label>
            <label
              className={`${styles.label} ${styles.caffeineSensitivity} ${
                errors.caffeineSensitivity ? styles.warning : ''
              } caffeineSensitivity`}
              {...register('caffeineSensitivity', {
                value: 0,
                validate: () =>
                  !/^[1-9]$/g.test(watch().caffeineSensitivity)
                    ? '카페인 예민도를 선택해주세요.'
                    : true,
              })}
            >
              <div className={styles.labelWrap}>
                <span>*</span>
                <span>카페인 예민도</span>
              </div>
              <ul
                className={`${styles.checkboxArea} ${
                  isMobile ? styles.isMobile : ''
                }`}
              >
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().caffeineSensitivity == 1 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('caffeineSensitivity', 1)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>없음</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().caffeineSensitivity == 2 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('caffeineSensitivity', 2)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>약간</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().caffeineSensitivity == 3 ? styles.hit : ''
                  }`}
                  onClick={() => setValue('caffeineSensitivity', 3)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>예민</span>
                </li>
              </ul>
            </label>
            <label
              className={`${styles.label} ${
                errors.dietPillsExperience ? styles.warning : ''
              } dietPillsExperience`}
              {...register('dietPillsExperience', {
                value: [false, false, false, false],
                validate: () =>
                  watch().dietPillsExperience &&
                  !watch().dietPillsExperience.includes(true)
                    ? '다이어트 약 복용 경험을 선택해주세요.'
                    : true,
              })}
            >
              <div className={styles.labelWrap}>
                <span>*</span>
                <span>다이어트 약 복용 경험</span>
              </div>
              <ul
                className={`${styles.checkboxArea} ${
                  isMobile ? styles.isMobile : ''
                }`}
              >
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[0]
                      ? styles.hitCheck
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      true,
                      false,
                      false,
                      false,
                    ]);
                    setValue('dietPillsLevel', 0);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>없음</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[1]
                      ? styles.hitCheck
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      false,
                      !watch().dietPillsExperience[1],
                      watch().dietPillsExperience[2],
                      watch().dietPillsExperience[3],
                    ]);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>한약</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[2]
                      ? styles.hitCheck
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      false,
                      watch().dietPillsExperience[1],
                      !watch().dietPillsExperience[2],
                      watch().dietPillsExperience[3],
                    ]);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>양약</span>
                </li>
                <li
                  className={`${styles.customCheckBoxWrap} ${
                    watch().dietPillsExperience &&
                    watch().dietPillsExperience[3]
                      ? styles.hitCheck
                      : ''
                  }`}
                  onClick={() => {
                    setValue('dietPillsExperience', [
                      false,
                      watch().dietPillsExperience[1],
                      watch().dietPillsExperience[2],
                      !watch().dietPillsExperience[3],
                    ]);
                  }}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>보조제</span>
                </li>
              </ul>
            </label>
            {watch().dietPillsExperience &&
              !watch().dietPillsExperience[0] &&
              !isSupplyment &&
              watch().dietPillsExperience.includes(true) && (
                <>
                  <label
                    className={`${styles.label} ${
                      errors.dietPillsLevel ? styles.warning : ''
                    } dietPillsLevel`}
                    {...register('dietPillsLevel', {
                      value: 0,
                      validate: () =>
                        !/^[1-9]$/g.test(watch().dietPillsLevel)
                          ? '복용 약 단계 및 강도를 선택해주세요.'
                          : true,
                      // required: {
                      //   value:
                      //     watch().dietPillsExperience &&
                      //     !watch().dietPillsExperience[0] &&
                      //     true,
                      //   message: '복용 약 단계 및 강도를 선택해주세요.',
                      // },
                    })}
                  >
                    <div className={styles.labelWrap}>
                      <span>*</span>
                      <span>복용 약 단계 및 강도</span>
                    </div>
                    <ul
                      className={`${styles.checkboxArea} ${
                        isMobile ? styles.isMobile : ''
                      }`}
                    >
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 1 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 1)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>모름</span>
                      </li>
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 2 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 2)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>약함</span>
                      </li>
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 3 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 3)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>보통</span>
                      </li>
                      <li
                        className={`${styles.customCheckBoxWrap} ${
                          watch().dietPillsLevel == 4 ? styles.hit : ''
                        }`}
                        onClick={() => setValue('dietPillsLevel', 4)}
                      >
                        <div className={styles.customCheckBox}></div>
                        <span>강함</span>
                      </li>
                    </ul>
                  </label>
                  <label
                    className={`${styles.label} ${
                      errors.sideEffects ? styles.warning : ''
                    }`}
                  >
                    <div className={styles.labelWrap}>
                      <span>*</span>
                      <span>복용 시 불편사항</span>
                    </div>
                    <div
                      className={`${styles.inputWrap} ${
                        errors.sideEffects ? styles.validationError : ''
                      }`}
                    >
                      <textarea
                        className={`${styles.sideEffects} sideEffects`}
                        {...register('sideEffects', {
                          value: '',
                          required: {
                            value:
                              watch().dietPillsExperience &&
                              !watch().dietPillsExperience[0] &&
                              true,
                            message:
                              '다이어트 약 복용시 불편사항을 입력해주세요.',
                          },
                        })}
                      ></textarea>
                    </div>
                  </label>
                </>
              )}
          </div>
          <div
            className={`${styles.diseaseCheckWrap} ${
              errors.disease ? styles.warning : ''
            } disease`}
            {...register('disease', {
              required: {
                value: watch().disease == undefined,
                message: '질병 여부를 선택해주세요.',
              },
            })}
          >
            <div className={styles.checkArea}>
              <div>
                <span>*</span>
                <span>질병 여부</span>
              </div>
              <div className={styles.checkOutWrap}>
                <div
                  className={`${styles.customCheckBoxWrap} ${
                    watch().disease ? styles.hit : ''
                  }`}
                  onClick={() => setValue('disease', true)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>예</span>
                </div>
                <div
                  className={`${styles.customCheckBoxWrap} ${
                    watch().disease === false ? styles.hit : ''
                  }`}
                  onClick={() => setValue('disease', false)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>아니오</span>
                </div>
              </div>
            </div>
            {watch().disease && (
              <>
                <span className={styles.sectionGuide}>
                  앓고 있는 질환을 상세히 작성해주세요.
                </span>
                <textarea
                  placeholder="예) 불면증, 당뇨"
                  {...register('diseaseDetail', {
                    value: '',
                  })}
                />
              </>
            )}
          </div>
          <div
            className={`${styles.medicineCheckWrap} ${
              errors.medicine ? styles.warning : ''
            } medicine`}
            {...register('medicine', {
              required: {
                value: watch().medicine == undefined,
                message: '복용중인 약 여부를 선택해주세요.',
              },
            })}
          >
            <div className={styles.checkArea}>
              <div>
                <span>*</span>
                <span>복용중인 약</span>
              </div>
              <div className={styles.checkOutWrap}>
                <div
                  className={`${styles.customCheckBoxWrap} ${
                    watch().medicine ? styles.hit : ''
                  }`}
                  onClick={() => setValue('medicine', true)}
                  // onClick={() => setMedicine(true)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>예</span>
                </div>
                <div
                  className={`${styles.customCheckBoxWrap} ${
                    watch().medicine === false ? styles.hit : ''
                  }`}
                  onClick={() => setValue('medicine', false)}
                >
                  <div className={styles.customCheckBox}></div>
                  <span>아니오</span>
                </div>
              </div>
            </div>
            {watch().medicine && (
              <>
                <span className={styles.sectionGuide}>
                  복용중인 약의 종류를 작성해주세요
                </span>
                <textarea
                  placeholder="예) 수면제(벤조디아제핀)"
                  // value={medicineDetail}
                  // onChange={(e) => setMedicineDetail(e.currentTarget.value)}
                  {...register('medicineDetail', {
                    value: '',
                  })}
                />
              </>
            )}
          </div>
        </div>
        <div
            className={`${styles.cautionWrap} ${
                errors.cautionCheck ? styles.isError : ''
            }`}
        >
            <div className={styles.labelWrap}>
              <span>*</span>
              <span>주의사항</span>
            </div>
            <ul>
              <li>
                <span>1.&nbsp;</span>
                <span>
                  빠른 감량 원하시는 분들은 식사 1시간 전 (점심, 저녁 전) 으로
                  하루 2번 복용이 원칙입니다.
                </span>
              </li>
              <li>
                <span>2.&nbsp;</span>
                <span>
                  수면이 불편하신 분들은 저녁복용을 오후 4시로 당겨서
                  복용합니다.
                </span>
              </li>
              <li>
                <span>3.&nbsp;</span>
                <span>
                  초기 적응기간 3~4일 동안 예민하게 느끼시는 분들은 복용량을
                  절반으로 줄여 드시다가 적응 후 정량 드시면 됩니다.
                </span>
              </li>
            </ul>
            <div
              className={`${styles.confirm} ${
                watch().cautionCheck ? styles.hit : ''
              }`}
              {...register('cautionCheck', {
                value: false,
                required: {
                  value: watch().cautionCheck == false,
                  message: '주의사항을 확인 후 체크 버튼을 눌러주세요.',
                },
              })}
              onClick={() => setValue('cautionCheck', !watch().cautionCheck)}
            >
              <div className={styles.customCheckBox}></div>
              <span>복용에 관한 주의사항을 확인했습니다.</span>
            </div>
          </div>
          <div
            className={`${styles.btnWrap} ${!isDesktop ? styles.isMobile : ''}`}
          >
            <button
              className={styles.submitBtn}
              onClick={handleSubmit(onSubmit, onSubmitError)}
            >
              다음
            </button>
          </div>
      </div>

      {/* 본인인증 모달 */}
      <UnifiedAuthModal
        isOpen={isAuthenticationModalOpen}
        onClose={handleAuthModalClose}
        onSuccess={handleAuthSuccess}
        purpose="order"
        pendingData={pendingSubmitData}
        returnPath={location.pathname + location.search}
      />
    </div>
  );
}
export default Questionnaire;
